// extracted by mini-css-extract-plugin
export default {"component":"IsClassicNetwork_component__XPlLK"};